import { render, staticRenderFns } from "./advertisementBox.vue?vue&type=template&id=914648a8&scoped=true"
import script from "./advertisementBox.vue?vue&type=script&lang=js"
export * from "./advertisementBox.vue?vue&type=script&lang=js"
import style0 from "./advertisementBox.vue?vue&type=style&index=0&id=914648a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914648a8",
  null
  
)

export default component.exports